import { render, staticRenderFns } from "./SetDetails.vue?vue&type=template&id=8a13d6be&scoped=true&"
import script from "./SetDetails.vue?vue&type=script&lang=js&"
export * from "./SetDetails.vue?vue&type=script&lang=js&"
import style0 from "./SetDetails.vue?vue&type=style&index=0&id=8a13d6be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a13d6be",
  null
  
)

export default component.exports